import { useLanguage } from '../../contexts/LanguageContext';
import { cn } from '../../lib/utils';

export const STRAVA_API_AGREEMENT_URL = 'https://www.strava.com/legal/api';

export default function StravaConnectConsentText({ className }) {
  const { t } = useLanguage();

  return (
    <p className={cn('text-xs text-muted-foreground leading-relaxed', className)}>
      {t('strava.connectConsentLead')}{' '}
      <a
        href={STRAVA_API_AGREEMENT_URL}
        target='_blank'
        rel='noopener noreferrer'
        className='text-primary underline underline-offset-2 hover:text-primary/90 font-medium'
      >
        {t('strava.connectConsentLinkLabel')}
      </a>
    </p>
  );
}
